import { GET_STATEFARM_DASHBOARD_API } from '../constants/AppConstants';

export default async (appliedReportAnalyticsFilters = {}) => {
  try {
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    };

    const startDate = formatDate(appliedReportAnalyticsFilters.startDate);
    let endDateRaw = appliedReportAnalyticsFilters.endDate;
    if (endDateRaw) {
      const dateObj = new Date(endDateRaw);
      dateObj.setDate(dateObj.getDate() + 1);
      endDateRaw = dateObj.toISOString();
    }
    const endDate = formatDate(endDateRaw);

    const url = `${GET_STATEFARM_DASHBOARD_API}?startDate=${startDate}&endDate=${endDate}`;

    const response = await fetch(url);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
